import React, { useCallback, useContext, useMemo, useState } from 'react';
import { withPerfMarker } from '@bingads-webui/performance-marker-react-wrapper';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { StepContainer } from '../step-container/step-container';
import { TagSetupSendToDeveloperView } from './view/tag-setup-send-to-developer-view';
import { GoalCreationWizardContext } from '../../goal-creation-wizard-context';

const TagSetupSendToDeveloperStepUnstyled = () => {
  const wizardContext = useContext(GoalCreationWizardContext);
  const {
    logActivity,
    scope,
    serverContext,
    goalContext,
  } = wizardContext;
  const i18n = useContext(I18nContext);
  const [allowNext, setAllowNext] = useState(false);

  const handleCancel = useCallback(() => {
    wizardContext.exitWizard();
  }, [wizardContext]);

  const setIsValid = useCallback(isValid => setAllowNext(isValid), []);

  const footerConfig = useMemo(() => ({
    buttons: [{
      type: 'Secondary',
      onClick: wizardContext.goBack,
      isEnabled: true,
      text: i18n.getString(_TL_(('Back'))),
    },
    {
      type: 'Primary',
      onClick: wizardContext.goToNext,
      isEnabled: allowNext,
      text: i18n.getString(_TL_(('Next'))),
    },
    {
      type: 'Cancel',
      onClick: handleCancel,
      isEnabled: true,
      text: i18n.getString(_TL_(('Cancel'))),
    }],
  }), [wizardContext.goBack, wizardContext.goToNext, i18n, allowNext, handleCancel]);

  return (
    <StepContainer
      subContainer
      step="tag-setup-selection"
      footerConfig={footerConfig}
      title={i18n.getString(_TL_('Send the tag to a developer'))}
    >
      <TagSetupSendToDeveloperView
        i18n={i18n}
        scope={scope}
        serverContext={serverContext}
        logActivity={logActivity}
        tagId={goalContext.Tag && goalContext.Tag.Id}
        goalContext={goalContext}
        setIsValid={setIsValid}
        permissions={wizardContext.permissions}
      />
    </StepContainer>
  );
};

export const TagSetupSendToDeveloperStep = withPerfMarker(TagSetupSendToDeveloperStepUnstyled);
